import Layout from "@/layout";
export default {
  path: "AuditManagement",
  component: () => import('@/views/AppMain/index'),
  name: "AuditManagement",
  hidden: false,
  alwaysShow: true,
  meta: {
    title: "审核管理",
    keepAlive: false,
    icon: '1045',
    activeIcon: '1046',
    activeMenu: '/HeadOfficeManagement/AuditManagement'
  },
  children: [
    {
      hidden: false,
      path: "AuditManagementList",
      component: () => import("@/views/HeadOfficeManagement/AuditManagement/AuditManagementList"),
      name: "AuditManagementList",
      meta: {
        title: "审核管理",
        keepAlive: false,
      }
    },{
      hidden: true,
      path: "AuditDetail",
      component: () => import("@/views/HeadOfficeManagement/AuditManagement/AuditDetail"),
      name: "AuditDetail",
      meta: {
        title: "审核详情",
        keepAlive: false,
        activeMenu:"/HeadOfficeManagement/AuditManagement/AuditManagementList"
      }
    },{
      hidden: false,
      path: "AuditProcess",
      component: () => import("@/views/HeadOfficeManagement/AuditManagement/AuditProcess"),
      name: "AuditProcess",
      meta: {
        title: "审核流程管理",
        keepAlive: true,
      }
    },{
      hidden: false,
      path: "AuditSetting",
      component: () => import("@/views/HeadOfficeManagement/AuditManagement/AuditSetting"),
      name: "AuditSetting",
      meta: {
        title: "审核类型设置",
        keepAlive: true,
      }
    },
  ]
};
